import React, { Fragment, useState, useEffect } from 'react';
import { CollapseCard } from 'components/UI';
import { useStyles } from './Actions.styled';
import { useSelector } from 'react-redux';
import { ChangeUserStatusModal, ReservationModal, ChangeUserRoleModal } from 'components/Modals';
import i18n from 'i18n-js';

import {
  Divider,
  List,
  ListItem,
  ListItemText,
  IconButton,
  ListItemSecondaryAction,
} from '@material-ui/core';

import ArrowForwardIcon from '@material-ui/icons/ArrowForward';

const Actions = ({ id, listStyles }) => {
  const classes = useStyles();
  const { user } = useSelector((state) => state.users);
  const { loading } = useSelector((state) => state.users || {});
  const [openRoleModal, setOpenRoleModal] = useState(false);
  const [openStatusModal, setOpenStatusModal] = useState(false);
  const [openReservationModal, setOpenReservationModal] = useState(false);

  const [disableAction, setDisableAction] = useState({});

  useEffect(() => {
    if (!loading) {
      setDisableAction({});
    }
  }, [loading, setDisableAction]);

  const handleModalOpen = (type) => {
    switch (type) {
      case 'status':
        setOpenStatusModal((prevState) => !prevState);
        break;
      case 'role':
        setOpenRoleModal((prevState) => !prevState);
        break;
      case 'create_reservation':
        setOpenReservationModal((prevState) => !prevState);
        break;

      default:
        break;
    }
  };

  const actions = [
    {
      hide: true,
      title: i18n.t('reservations.create_reservation'),
      onClick: () => handleModalOpen('create_reservation'),
      datacy: 'create-reservation-action',
    },
    {
      title: i18n.t('users.change_role'),
      onClick: () => handleModalOpen('role'),
      datacy: 'change-role-action',
    },
    {
      title: i18n.t('users.change_status'),
      onClick: () => handleModalOpen('status'),
      datacy: 'change-status-action',
    },
  ];

  return (
    <CollapseCard title="Actions" dataCy="employee-details-actions" customClasses={classes}>
      <List>
        {actions
          .filter((action) => !action.hide)
          .map((item, index) => (
            <Fragment key={index}>
              <ListItem
                classes={{
                  root: classes.listItem,
                }}
              >
                <ListItemText
                  classes={listStyles}
                  primary={i18n.t(`actions.${item.title}`, { defaultValue: item.title })}
                />
                <ListItemSecondaryAction>
                  <IconButton
                    disabled={disableAction[item.title]}
                    onClick={item.onClick}
                    datacy={item?.datacy}
                    edge="end"
                    classes={{
                      label: classes.label,
                      root: classes.iconRoot,
                    }}
                    aria-label="right"
                  >
                    <ArrowForwardIcon />
                  </IconButton>
                </ListItemSecondaryAction>
              </ListItem>

              {index !== actions.length - 1 && <Divider light={true} className={classes.divider} />}
            </Fragment>
          ))}
      </List>
      {openStatusModal && (
        <ChangeUserStatusModal
          id={id}
          open={openStatusModal}
          status={user?.status}
          handleClick={() => handleModalOpen('status')}
          userType="EMPLOYEE"
        />
      )}
      {openReservationModal && (
        <ReservationModal
          user={user}
          open={openReservationModal}
          handleClick={() => handleModalOpen('create_reservation')}
        />
      )}
      {openRoleModal && (
        <ChangeUserRoleModal
          id={user?.id}
          role={user?.role}
          open={openRoleModal}
          handleClick={() => handleModalOpen('role')}
        />
      )}
    </CollapseCard>
  );
};

export default Actions;
